import api from './api';

const createVenda = async (vendaData) => {
    const { data } = await api.post('/vendas', vendaData);
    return data;
};

const vendaService = { createVenda };
export default vendaService;